module.exports = __webpack_public_path__ + "static/media/remove-icon-red.d07a050b.svg";